// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"63ef55f823a206152ea8","883":"c9d531d17b88929b9d4f"}[chunkId] + ".js";
};